// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  KyberNetwork,
  Messages2,
  Calendar1,
  Kanban,
  Profile2User,
  Bill,
  UserSquare,
  ShoppingBag,
  Chart21,
  Graph,
  Dash,
  Home,
  Headphone,
  People,
  Flag,
  Activity,
  User,
  Setting2
} from 'iconsax-react';

import PieChartIcon from '@mui/icons-material/PieChart';
// type
import { NavItemType } from 'types/menu';
import { routePermissions } from 'contexts/PermissionGuard';

// icons
const icons = {
  applications: KyberNetwork,
  chat: Messages2,
  calendar: Calendar1,
  kanban: Kanban,
  customer: Profile2User,
  invoice: Bill,
  profile: UserSquare,
  ecommerce: ShoppingBag,
  charts: Chart21,
  chart: Graph,
  dash: Dash,
  pieChart: PieChartIcon,
  home: Home,
  channels: Headphone,
  contactgroup: People,
  campaigns: Flag,
  campaignsdashboard: Activity,
  user: User,
  communities: People,
  administracao: Setting2
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const applications: NavItemType[] = [
  {
    id: 'group-inicio',
    type: 'group',
    children: [
      {
        id: 'dashboard',
        title: <FormattedMessage id="Início" />,
        type: 'item',
        icon: icons.home,
        url: '/home',
        permissions: routePermissions.home
      }
    ]
  },
  {
    id: 'group-atendimento',
    type: 'group',
    children: [
      {
        id: 'react-chat',
        title: <FormattedMessage id="Atendimento" />,
        type: 'collapse',
        icon: icons.chat,
        children: [
          {
            id: 'chat',
            title: <FormattedMessage id="Bate papo" />,
            type: 'item',
            url: '/chat',
            permissions: routePermissions.chat
          },
          {
            id: 'relatorio_atendimento',
            title: <FormattedMessage id="Relatório Atendimento" />,
            type: 'item',
            url: '/relatorio-atendimentos',
            permissions: routePermissions['relatorio-atendimentos']
          },
          {
            id: 'dashboard_atendimento',
            title: <FormattedMessage id="Dashboard Atendimento" />,
            type: 'item',
            url: '/dashboard-atendimentos',
            permissions: routePermissions['dashboard-atendimentos']
          },
          {
            id: 'wa_template_cloud_api',
            title: <FormattedMessage id="Modelo de Mensagens" />,
            type: 'item',
            url: '/whatsApp-Template',
            permissions: routePermissions.templates
          }
        ]
      }
    ]
  },
  {
    id: 'group-contatos',
    type: 'group',
    children: [
      {
        id: 'react-contatos',
        title: <FormattedMessage id="Contatos" />,
        type: 'collapse',
        icon: icons.profile,
        children: [
          {
            id: 'contatos',
            title: <FormattedMessage id="Lista de contatos" />,
            type: 'item',
            url: '/contatos/lista',
            permissions: routePermissions.contatos
          },
          {
            id: 'grupocontatos',
            title: <FormattedMessage id="Grupo Contatos" />,
            type: 'item',
            url: '/contatos/grupos',
            permissions: routePermissions.grupos
          }
        ]
      }
    ]
  },
  {
    id: 'group-canais',
    type: 'group',
    children: [
      {
        id: 'react-canais',
        title: <FormattedMessage id="Canais" />,
        type: 'collapse',
        icon: icons.channels,
        children: [
          {
            id: 'canais',
            title: <FormattedMessage id="Gerenciar canais" />,
            type: 'item',
            url: '/canais',
            permissions: routePermissions.canais
          }
        ]
      }
    ]
  },
  {
    id: 'group-campanhas',
    type: 'group',
    children: [
      {
        id: 'react-campanhas',
        title: <FormattedMessage id="Campanhas" />,
        type: 'collapse',
        icon: icons.campaigns,
        children: [
          {
            id: 'campanhas',
            title: <FormattedMessage id="Gerenciar campanhas" />,
            type: 'item',
            url: '/campanhas',
            permissions: routePermissions.campanhas
          },
          {
            id: 'dashboardcampanhas',
            title: <FormattedMessage id="Dashboard campanha" />,
            type: 'item',
            url: '/dashboard-campanhas',
            permissions: routePermissions['dashboard-campanhas']
          }
        ]
      }
    ]
  },
  {
    id: 'group-comunidades',
    type: 'group',
    children: [
      {
        id: 'react-comunidades',
        title: <FormattedMessage id="Comunidades" />,
        type: 'collapse',
        icon: icons.communities,
        children: [
          {
            id: 'comunidades',
            title: <FormattedMessage id="Gerenciar comunidades" />,
            type: 'item',
            url: '/comunidades',
            permissions: routePermissions.comunidades
          }
        ]
      }
    ]
  },
  {
    id: 'group-administracao',
    icon: icons.administracao,
    type: 'group',
    children: [
      {
        id: 'react-administracao',
        title: <FormattedMessage id="Administração" />,
        type: 'collapse',
        icon: icons.administracao,
        children: [
          {
            id: 'usario',
            title: <FormattedMessage id="Usuários" />,
            type: 'item',
            url: '/usuario',
            permissions: routePermissions.usuario
          },
          {
            id: 'perfis',
            title: <FormattedMessage id="Perfis" />,
            type: 'item',
            url: '/administracao/perfis',
            permissions: routePermissions.administracao
          },
          {
            id: 'atendimento-config',
            title: <FormattedMessage id="Atendimento" />,
            type: 'item',
            url: '/administracao/atendimento',
            permissions: routePermissions['administracao-atendimento']
          },
          {
            id: 'notificacoes-config',
            title: <FormattedMessage id="Notificações" />,
            type: 'item',
            url: '/administracao/notificacoes',
            permissions: routePermissions['administracao-notificacoes']
          },
          {
            id: 'cadastros',
            title: <FormattedMessage id="Cadastros" />,
            type: 'item',
            url: '/administracao/cadastros',
            permissions: routePermissions.cadastros
          },
          {
            id: 'auditoria',
            title: <FormattedMessage id="Auditoria" />,
            type: 'item',
            url: '/administracao/auditoria',
            permissions: routePermissions['administracao-auditoria']
          }
        ]
      }
    ]
  }
];

export default applications;
